import { jsx } from "react/jsx-runtime";
import DTICalculator from "./DTICalculator.esm.js";
const DTICalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      annualIncome = 7e3,
      minCreditCardPayments = 200,
      carLoanPayments = 50,
      studentLoanPayments = 300,
      alimonySupportPayments = 0,
      secondaryHomeExpenses = 0,
      otherDebtPayments = 0
    } = attrs;
    const defaultValues = {
      annualIncome,
      minCreditCardPayments,
      carLoanPayments,
      studentLoanPayments,
      alimonySupportPayments,
      secondaryHomeExpenses,
      otherDebtPayments
    };
    return /* @__PURE__ */ jsx(DTICalculator, { ...{
      defaultValues
    } });
  },
  metadata: {
    version: "1.0",
    name: "constellation/dti-calculator",
    title: "DTI calculator",
    description: "Calculate a debt-to-income (DTI) ratio from monthly income and debts.",
    icon: "businessperson",
    keywords: ["mortgages", "calculators", "debt", "income"],
    category: "Calculators",
    supports: {
      customClassName: false,
      html: false
    },
    attributes: {
      annualIncome: {
        type: "number",
        label: "Annual income",
        default: 7e3,
        control: "number"
      },
      minCreditCardPayments: {
        type: "number",
        label: "Min. credit card payments",
        default: 200,
        control: "number"
      },
      carLoanPayments: {
        type: "number",
        label: "Car loan payments",
        default: 50,
        control: "number"
      },
      studentLoanPayments: {
        type: "number",
        label: "Student loan payments",
        default: 300,
        control: "number"
      },
      alimonySupportPayments: {
        type: "number",
        label: "Alimony/child support payments",
        default: 0,
        control: "number"
      },
      secondaryHomeExpenses: {
        type: "number",
        label: "Secondary home expenses",
        default: 0,
        control: "number"
      },
      otherDebtPayments: {
        type: "number",
        label: "Other loan or debt payments",
        default: 0,
        control: "number"
      }
    }
  }
};
export {
  DTICalculatorBlock as default
};
